import Page from '@/components/Page.vue';

import Home from '@/components/generalPages/Home.vue';
import Onboarding from '@/components/generalPages/Onboarding.vue';
import UserProfile from '@/components/profile/UserProfile.vue';
import Messages from '@/components/messages/Messages.vue';
import Friends from '@/components/generalPages/Friends.vue';
import Applications from '@/components/applications/Applications.vue';
import Invitations from '@/components/invitations/Invitations.vue';
import InviteFriend from '@/components/generalPages/InviteFriend.vue';
import Notifications from '@/components/notifications/Notifications.vue';
import ConnectionsPage from '@/components/profile/ConnectionsPage.vue';
import Search from '@/components/generalPages/Search.vue';

import UserEvents from '@/components/events/UserEvents.vue';
import EventPage from '@/components/events/EventPage.vue';
import EventForm from '@/components/events/EventForm.vue';
import SearchHeroes from '@/components/searchEventParticipants/SearchHeroes.vue';

import UserTeams from '@/components/teams/UserTeams.vue';
import TeamPage from '@/components/teams/TeamPage.vue';
import TeamForm from '@/components/teams/TeamForm.vue';
import SearchTeammates from '@/components/SearchTeammates/SearchTeammates.vue';

import PrivacyPolicy from '@/components/privacyPolicy/PrivacyPolicy.vue';
import PersonalDataDeletion from '@/components/privacyPolicy/PersonalDataDeletion.vue';

import Login from '@/components/unregisteredUsersPages/login.vue';
import Registration from '@/components/unregisteredUsersPages/Registration.vue';
import WantToRegister from '@/components/unregisteredUsersPages/WantToRegister.vue';
import PasswordReset from '@/components/unregisteredUsersPages/PasswordReset.vue';
import NotFound from '@/components/unregisteredUsersPages/NotFound.vue';

import RegistrationRequestList from '@/components/administration/RegistrationRequestList.vue';

const routes = [
  {
    path: '/',
    components: { default: Page },
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home,
      },
      {
        path: '/user/:link?/:tab?',
        name: 'UserProfile',
        component: UserProfile,
      },
      {
        path: '/events',
        name: 'Events',
        component: UserEvents,
      },
      {
        path: '/events/:link',
        name: 'EventPage',
        component: EventPage,
      },
      {
        path: '/new-event',
        name: 'EventForm',
        component: EventForm,
      },
      {
        path: '/search-heroes',
        name: 'SearchHeroes',
        component: SearchHeroes,
      },
      {
        path: '/messages',
        name: 'Messages',
        component: Messages,
      },
      {
        path: '/friends',
        name: 'Friends',
        component: Friends,
      },
      {
        path: '/teams',
        name: 'Teams',
        component: UserTeams,
      },
      {
        path: '/teams/:link',
        name: 'TeamPage',
        component: TeamPage,
      },
      {
        path: '/create-new-team',
        name: 'TeamForm',
        component: TeamForm,
      },
      {
        path: '/search-teammates',
        name: 'SearchTeammates',
        component: SearchTeammates,
      },
      {
        path: '/applications',
        name: 'Applications',
        component: Applications,
      },
      {
        path: '/invitations',
        name: 'Invitations',
        component: Invitations,
      },
      {
        path: '/invite-friend',
        name: 'InviteFriend',
        component: InviteFriend,
      },
      {
        path: '/notifications',
        name: 'Notifications',
        component: Notifications,
      },
      {
        path: '/search',
        name: 'Search',
        component: Search,
      },
      {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
      },
      {
        path: '/personal-data-deletion',
        name: 'PersonalDataDeletion',
        component: PersonalDataDeletion,
      },
      {
        path: '/registration-requests',
        name: 'RegistrationRequests',
        component: RegistrationRequestList,
      },
      {
        path: '/connections',
        name: 'Connections',
        component: ConnectionsPage,
      },
      {
        path: '/404',
        name: 'NotFound',
        component: NotFound,
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    alias: '/confirm-email',
  },
  {
    path: '/',
    name: 'Onboarding',
    component: Onboarding,
  },
  {
    path: '/registration',
    name: 'Registration',
    component: Registration,
    alias: '/register-by-invitation',
  },
  {
    path: '/reset-password',
    name: 'PasswordReset',
    component: PasswordReset,
  },
  {
    path: '/want-to-register',
    name: 'WantToRegister',
    component: WantToRegister,
  },
  {
    path: '/:pathMatch(.*)*', // 404
    redirect: '/404',
  },
];

export default routes;
